import Autocomplete, {
  AutocompleteProps,
  AutocompleteRenderInputParams,
} from '@mui/material/Autocomplete'

import TextField from './TextField'

type OptionShape = {
  label: string
  value: any
}

interface AutocompleteFieldProps<
  T,
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
  FreeSolo extends boolean | undefined,
> extends Omit<
    AutocompleteProps<T, Multiple, DisableClearable, FreeSolo>,
    'renderInput'
  > {
  helperText?: string
  label?: string
  name?: string
  options: T[]
  placeholder?: string
  renderInput?: (params: AutocompleteRenderInputParams) => React.ReactNode
}

const AutocompleteField = <
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
  FreeSolo extends boolean | undefined,
>({
  helperText,
  label,
  name,
  options,
  placeholder,
  value,
  ...props
}: AutocompleteFieldProps<
  OptionShape,
  Multiple,
  DisableClearable,
  FreeSolo
>) => {
  const handleOptionValueEquality = (
    option: OptionShape,
    value: OptionShape | string,
  ) => {
    return typeof value === 'string'
      ? option.value === value
      : option.value === value.value
  }

  return (
    <Autocomplete
      autoHighlight
      fullWidth
      getOptionLabel={(option: OptionShape) => option?.label || ''}
      isOptionEqualToValue={handleOptionValueEquality}
      options={options}
      renderInput={(params) => (
        <TextField
          helperText={helperText}
          label={label}
          name={name}
          placeholder={placeholder}
          {...params}
        />
      )}
      value={value}
      {...props}
    />
  )
}

export default AutocompleteField
